import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import { ethers } from 'ethers';
import PlayerIcon from '../Utils/PlayerIcon';

interface IProps {
  player1: string;
  player2: string;
}

const shorter = (str: any) =>
  str?.length > 8 ? `${str.slice(0, 5)}...${str.slice(-4)}` : str;

const TnCGamePlayers: React.FC<IProps> = ({ player1, player2 }: IProps) => {
  // context
  const { account } = useWeb3React<Web3Provider>();

  return (
    <>
      <div className="playerWrapper">
        <div className="playerIcon">
          <PlayerIcon active={account === player1} />
        </div>
        <div
          className="playerText"
          style={{ color: account === player1 ? '#f8f8f8' : '#d3d3d3' }}
        >
          {player1 !== ethers.constants.AddressZero ? shorter(player1) : '-'}
        </div>
      </div>
      <div className="playerWrapper">
        <div className="playerIcon">
          <PlayerIcon active={account === player2} />
        </div>
        <div
          className="playerText"
          style={{ color: account === player2 ? '#f8f8f8' : '#d3d3d3' }}
        >
          {player2 !== ethers.constants.AddressZero ? shorter(player2) : '-'}
        </div>
      </div>
    </>
  );
};

export default TnCGamePlayers;
